/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { sarsaparillaReducers, store as sarsaparillaStore } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth';

import { externalRatingReviewsReducers } from 'ui-rating-review';
import { permitContentReducers } from 'ui-permit';

import moduleReducers from '../src/reducers/permit';
import sharedModuleReducers from '../src/reducers/shared';
import moduleStore from '../src/store';

const rootReducer = combineReducers({
    // boundary waters reducers
    boundarywaters: moduleReducers,
    boundarywatersShared: sharedModuleReducers,

    permitContent: permitContentReducers,

    // Ratings and review reducers
    ratingReviews: externalRatingReviewsReducers,
    ...sarsaparillaReducers,

    // Auth - MUST COME AFTER SARSA REDUCERS DURING AUTH MIGRATION
    ...authReducers,
});

const initialState = {
    ...moduleStore(),
    ...sarsaparillaStore(),
};

export function setupStore(preloadedState?: any) {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: [
                        'launchdarkly', // Has ld client object in reducer
                    ],
                },
            });
        },
        preloadedState,
        devTools: process.env.DEV_TOOLS_ENABLED,
    });
}

export const store = setupStore(initialState);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

// cSpell:ignore reduxjs, boundarywaters
